import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Person } from 'components/UI';
import DOMPurify from "dompurify";
import '../../Verdict.scss';
var VerdictDisplayFeedback = /*#__PURE__*/function (_Component) {
  function VerdictDisplayFeedback() {
    _classCallCheck(this, VerdictDisplayFeedback);
    return _callSuper(this, VerdictDisplayFeedback, arguments);
  }
  _inherits(VerdictDisplayFeedback, _Component);
  return _createClass(VerdictDisplayFeedback, [{
    key: "render",
    value: function render() {
      var feedback = '';
      if (this.props.verdict != null) {
        feedback = this.props.verdict.feedback;
      } else if (this.props.feedback != null) {
        feedback = this.props.feedback;
      } else if (this.props.value != null) {
        feedback = this.props.value;
      }
      if (feedback != null && feedback != '') {
        feedback = feedback.replace(/(\r\n|\r|\n)/g, '<br />');
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-feedback-display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text"
      }, this.props.verdict != null ? /*#__PURE__*/React.createElement(Person, {
        person: this.props.verdict
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      })) : feedback));
    }
  }]);
}(Component);
export default VerdictDisplayFeedback;